import React, { useState } from "react";
import { Form, Input } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

const FormPassword = ({
  label,
  name,
  rules,
  placeholder,
  size = "large",
  ...rest
}) => {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => {
    setVisible(!visible);
  };

  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      {...rest}
      className="custom-password-input"
    >
      <Input.Password
        placeholder={placeholder}
        size={size}
        iconRender={(visible) => (
          <span onClick={toggleVisibility}>
            {visible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
          </span>
        )}
        visibilityToggle={true}
      />
    </Form.Item>
  );
};

export default FormPassword;